import React from 'react';
import { useSelector } from 'react-redux';

import { getResourceTo } from 'react/utils/utils';
import Loading from '../Loading/Loading';
import ODIntegrationCard from './RoutePlannerIntegrationCard';
import WGLNIntegrationCard from './WGLNIntegrationCard';
import LocalzIntegrationCard from './LocalzIntegrationCard';

function IntegrationsContainer() {
  const isLoadingIntegrations = useSelector((state) => state.integrations.get('isLoadingIntegrations'));
  const integrationData = useSelector((state) => state.integrations.get('integrations') || []);

  const localzIntegration = useSelector((state) => state.localzIntegration?.toJS());

  return (
    <div data-testid="integrations" id="Integrations">
      <div className="TitleContainer">
        <p className="pageTitle">{getResourceTo('DescartesIntegrations.title')}</p>
        <p className="pageDescription">{getResourceTo('DescartesIntegrations.subtitle')}</p>
      </div>
      {isLoadingIntegrations && (
        <Loading width="74px" height="74px" />
      )}
      {!isLoadingIntegrations && (
        <div data-testid="IntegrationsContainer" className="IntegrationsContainer">
          {integrationData?.map((data) => (
            <ODIntegrationCard
              id={data.get('id')}
              key={data.getIn(['integration', 'name'])}
              integrationData={JSON.stringify(data.toJS())}
              active={data.get('enabled')}
              createdStatically={data.get('createdStatically', false)}
              {...data}
            />
          ))}
          <WGLNIntegrationCard />
          <LocalzIntegrationCard
            id={localzIntegration.id}
            integrationData={localzIntegration}
            active={localzIntegration?.integration?.enabled}
          />
        </div>
      )}
    </div>
  );
}

export default IntegrationsContainer;
